import React, { useEffect, useState } from "react";
import GlobalStyle from "./globalStyles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MainNavbar, MainFooter, Error404, AdminLogin } from "./components";
import {
  Home,
  CreateNftForm,
  NftDetail,
  AdminDashboard,
  Collection,
  NftsListing,
  UserProfile,
  ReportsListing,
  TransactionsListing,
  CollectionListing,
  CreateCollection,
  ProfileSetting,
  CategoryListing,
  UpdateCredentials,
  UserNftDetail,
  SellNft,
  AllNfts,
  ImportCollection,
  UsersCollection,
  Maintenance,
  CollectionAll,
  Rewards,
  RewardsListing,
  MainCollections,
} from "./pages";
import { GetConfigHook } from "hooks";

const App = () => {
  const { data } = GetConfigHook();

  return (
    <Router>
      <GlobalStyle />
      <MainNavbar />

      <div className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create/nft" element={<CreateNftForm />} />
          <Route path="/nft-details" element={<NftDetail />} />

          <Route path="/user-nft/:id" element={<UserNftDetail />} />
          <Route path="/user-nft/:id/sell" element={<SellNft />} />

          {/* <Route path="/collection/:id" element={<Collection />} /> */}
          <Route path="/collection/:id" element={<CollectionAll />} />
          <Route path="/create-collection" element={<CreateCollection />} />
          <Route path="/collections" element={<UsersCollection />} />
          <Route path="/collection-all" element={<MainCollections />} />
          {/* <Route path="/collection-all" element={<CollectionAll />} /> */}

          <Route path="/all-nfts" element={<AllNfts />} />

          <Route path="/*" element={<Error404 />} />
          <Route path="/profile/*" element={<UserProfile />} />
          <Route path="/profile-setting/*" element={<ProfileSetting />} />
          <Route path="/import-collection" element={<ImportCollection />} />
          <Route path="/maintenance" element={<Maintenance />} />

          <Route path="/rewards" element={<Rewards />} />

          {/* admin routes */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-dashboard/*" element={<AdminDashboard />} />
          <Route path="/admin/nfts" element={<NftsListing />} />
          <Route path="/admin/reports-list" element={<ReportsListing />} />
          <Route path="/admin/category" element={<CategoryListing />} />
          <Route path="/admin/rewards" element={<RewardsListing />} />
          <Route
            path="/admin/update-credentials"
            element={<UpdateCredentials />}
          />
          {/* <Route path="/admin/transactions-list" element={<TransactionsListing />} /> */}
          <Route
            path="/admin/collection-list"
            element={<CollectionListing />}
          />
          <Route
            path="/admin/transactions-list"
            element={<TransactionsListing />}
          />
        </Routes>
      </div>
      <MainFooter />
    </Router>
  );
};

export default App;
